import { CreatedItemResponseDTO } from "@/domain/dto/CreatedItemResponseDTO";
import { CreatePartnerDTO } from "@/domain/dto/CreatePartnerDTO";
import { IPartnerRepository } from "@/domain/repositories/IPartnerRepository";
import { ICreatePartnerUseCase } from "@/domain/usecases/ICreatePartnerUseCase";
import { PartnerValidator } from "../validators/PartnerValidator";
import { IAddUsersToPlanUseCase } from "@/domain/usecases/IAddUsersToPlanUseCase";
import { AddPlanDTO } from "@/domain/dto/AddUsersToPlanDTO";
import { PlanValidator } from "../validators/PlanValidator";

export class AddUsersToPlanUseCase implements IAddUsersToPlanUseCase {
    repository: IPartnerRepository
    constructor(repository: IPartnerRepository) {
        this.repository = repository
    }
    execute(params: AddPlanDTO): Promise<void> {
        PlanValidator.validateAddUsers(params)
        return this.repository.addUsersToPlan(params)
    }

}